import { isMobileDevice } from "../../../utils/mobile";

const MAX_MENU_HEIGHT = 390;

// CALCULATIONS:
//
// Desktop:
// 400px
//
// Mobile:
// window height
// minus appBar height (72px)
// minus padding below menu (12px from bottom of screen)
// minus 2px (there's 2 horizontal 1px strokes)
// minus 24px of padding

export const getMaxMenuHeight = () =>
  isMobileDevice() ? window.innerHeight - 72 - 12 - 2 - 24 : MAX_MENU_HEIGHT;

// CALCULATIONS:
//
// Desktop:
// 400px
//
// Mobile:
// window height
// minus appBar height (72px)
// minus padding below menu (12px from bottom of screen)
// minus tab and search bar height (90px tall)
// minus 4px (there's 4 horizontal 1px strokes)

export const getMaxTabMenuHeight = () =>
  isMobileDevice() ? window.innerHeight - 72 - 12 - 90 - 4 : MAX_MENU_HEIGHT;
